import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  CircularProgress,
  IconButton
} from '@mui/material';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import TimeEvent from './TimeEvent';

const primaryColor = '#5757b0';
const lightPurple = '#f0f0ff';
const hoverColor = '#7777d0';

const EventDetailsDialog = ({ open, onClose, event }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: lightPurple,
        color: primaryColor,
        fontWeight: 700,
        borderBottom: `2px solid ${primaryColor}`
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FactCheckIcon />
          <Typography variant="h6">{t('widget.event_details', 'Event Details')}</Typography>
        </Box>
        <IconButton onClick={onClose} size="small" sx={{ color: primaryColor }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 2, backgroundColor: '#fcfcfc' }}>
        <React.Suspense fallback={
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress size={40} sx={{ color: primaryColor }} />
          </Box>
        }>
          {event && (
            <TimeEvent
              timeevent={event}
              hideDates={false}
            />
          )}
        </React.Suspense>
      </DialogContent>
    </Dialog>
  );
};

export default EventDetailsDialog;
